import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RefreshCw, LogOut, Nfc, ScrollText, ClipboardList, Columns, ReceiptText, MailQuestion, CalendarClock, Landmark } from 'lucide-react';
import { Button } from '@/components/ui/button.jsx';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog.jsx';
import { resetAppState } from '@/lib/reset.js';
import { endSession } from '@/lib/session.js';

export default function More() {
  const navigate = useNavigate();
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <div className="min-h-screen p-4">
      <h1 className="text-xl font-semibold">More</h1>
      <p className="mt-2 text-sm text-text-muted">
        Everything with a live route that is not on the tab bar.
      </p>

      {/* Ship 4a nav cleanup: surfaces that left the primary nav when the
          queue took the landing slot stay one tap away here (no orphans). */}
      <div className="mt-6 border-t border-border pt-4">
        <button
          type="button"
          onClick={() => navigate('/pipeline')}
          className="flex w-full items-center gap-3 rounded-md px-3 py-3 text-sm text-text-muted hover:bg-border/20 min-h-[44px]"
        >
          <Columns size={16} strokeWidth={1.5} />
          Pipeline
        </button>
        <button
          type="button"
          onClick={() => navigate('/renewals')}
          className="flex w-full items-center gap-3 rounded-md px-3 py-3 text-sm text-text-muted hover:bg-border/20 min-h-[44px]"
        >
          <CalendarClock size={16} strokeWidth={1.5} />
          Renewals
        </button>
        <button
          type="button"
          onClick={() => navigate('/follow-ups')}
          className="flex w-full items-center gap-3 rounded-md px-3 py-3 text-sm text-text-muted hover:bg-border/20 min-h-[44px]"
        >
          <MailQuestion size={16} strokeWidth={1.5} />
          Follow-ups
        </button>
        <button
          type="button"
          onClick={() => navigate('/quote-inbox')}
          className="flex w-full items-center gap-3 rounded-md px-3 py-3 text-sm text-text-muted hover:bg-border/20 min-h-[44px]"
        >
          <ReceiptText size={16} strokeWidth={1.5} />
          Quote inbox
        </button>
        <button
          type="button"
          onClick={() => navigate('/blank-phf')}
          className="flex w-full items-center gap-3 rounded-md px-3 py-3 text-sm text-text-muted hover:bg-border/20 min-h-[44px]"
        >
          <ClipboardList size={16} strokeWidth={1.5} />
          Blank PHF
        </button>
        <button
          type="button"
          onClick={() => navigate('/money')}
          className="flex w-full items-center gap-3 rounded-md px-3 py-3 text-sm text-text-muted hover:bg-border/20 min-h-[44px]"
        >
          <Landmark size={16} strokeWidth={1.5} />
          Money
        </button>
        <button
          type="button"
          onClick={() => navigate('/admin/licenses')}
          className="flex w-full items-center gap-3 rounded-md px-3 py-3 text-sm text-text-muted hover:bg-border/20 min-h-[44px]"
        >
          <ScrollText size={16} strokeWidth={1.5} />
          Licenses
        </button>
        <button
          type="button"
          onClick={() => navigate('/admin/tap')}
          className="flex w-full items-center gap-3 rounded-md px-3 py-3 text-sm text-text-muted hover:bg-border/20 min-h-[44px]"
        >
          <Nfc size={16} strokeWidth={1.5} />
          TAP Keychains
        </button>
      </div>

      <div className="mt-2 border-t border-border pt-4">
        <button
          type="button"
          onClick={() => setConfirmOpen(true)}
          className="flex w-full items-center gap-3 rounded-md px-3 py-3 text-sm text-text-muted hover:bg-border/20 min-h-[44px]"
        >
          <RefreshCw size={16} strokeWidth={1.5} />
          Reload TRACON
        </button>
        <button
          type="button"
          onClick={async () => { await endSession(); navigate('/login', { replace: true }); }}
          className="flex w-full items-center gap-3 rounded-md px-3 py-3 text-sm text-text-muted hover:bg-border/20 min-h-[44px]"
        >
          <LogOut size={16} strokeWidth={1.5} />
          Sign out
        </button>
      </div>

      <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle>Reload TRACON</DialogTitle>
            <DialogDescription>
              Clears the app cache and reloads. Use this if something looks broken or out of date.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="flex gap-2 pt-2">
            <Button variant="outline" onClick={() => setConfirmOpen(false)}>
              Cancel
            </Button>
            <Button onClick={resetAppState}>
              Reload
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
